import { useVariantOptionState } from '@modules/product/context/VariantOptionContext';
import ColorPicker from './ColorPicker.mobile';
import ProductAttributeEnum from '@modules/product/config/product-attribute';
import type Variant from '@modules/product/type/variant';
import type ProductSize from '@modules/product/type/product-size';
import OptionPicker from './OptionPicker.mobile';
import { useStyles } from '@archipro-design/aria';
import * as S from './VariantSelector.mobile.style';
import SizePicker from './SizePicker.mobile';

interface VariantSelectorProps {
    data: {
        variants: Variant[];
        sizes: ProductSize[];
    };
}

const VariantSelector = ({
    data: { variants, sizes },
}: VariantSelectorProps) => {
    const { attributeMap } = useVariantOptionState();
    const colourAttribute = attributeMap.get(ProductAttributeEnum.Colour);
    const materialAttribute = attributeMap.get(ProductAttributeEnum.Material);
    const otherAttributes = [...attributeMap.values()].filter(
        (attr) =>
            attr.ID !== ProductAttributeEnum.Colour &&
            attr.ID !== ProductAttributeEnum.Material
    );
    const { css } = useStyles();

    return (
        <div>
            {colourAttribute && (
                <>
                    <ColorPicker
                        key={'option-picker' + ProductAttributeEnum.Colour}
                        data={{
                            variants,
                            options: colourAttribute.options,
                        }}
                        isGeneric={colourAttribute.isGeneric}
                    />
                    <hr className={css(S.Divider)} />
                </>
            )}
            {materialAttribute && (
                <>
                    <OptionPicker
                        data={{
                            attributeID: ProductAttributeEnum.Material,
                            label: materialAttribute.Name,
                            options: materialAttribute.options,
                            variants,
                        }}
                        isGeneric={materialAttribute.isGeneric}
                        hasManyOptions={materialAttribute.options.length > 1}
                    />
                    <hr className={css(S.Divider)} />
                </>
            )}
            {sizes.length > 0 && (
                <>
                    <SizePicker
                        data={{ sizes, variants }}
                        isGeneric={variants.every((v) => Boolean(v.Size))}
                        hasManyOptions={sizes.length > 1}
                    />
                    <hr className={css(S.Divider)} />
                </>
            )}
            {otherAttributes.map((attr) => (
                <>
                    <OptionPicker
                        key={'attr-picker-' + attr.ID}
                        data={{
                            attributeID: attr.ID,
                            label: attr.Name,
                            options: attr.options,
                            variants,
                        }}
                        isGeneric={attr.isGeneric}
                        hasManyOptions={attr.options.length > 1}
                    />
                    <hr className={css(S.Divider)} />
                </>
            ))}
        </div>
    );
};

export default VariantSelector;
